import React from 'react';
import { Paragraph, Link } from 'Common';
import Style from './InsuranceCompanyCourseTile.style';
import { TEXT } from 'locales/landingpages/insuranceCompany';
import { Headline } from '@missionme/mime_elements';
import { linkHandler } from 'utils/linkHandler';
import { trimText, removeParentheses } from 'utils';

export const InsuranceCompanyCourseTile = ({ offer }) => {
  return (
    <Style className={`insurance-company-course-tile ${offer?.slug}-tile`}>
      <Link
        to={linkHandler.get('healthInsuranceCooperationCourse', {
          cooperation: offer?.cooperationKey,
          course: offer?.slug
        })}
        className="mime-elements-link"
      >
        <div className="box-frame">
          <Paragraph white className="extra-small-bold">
            {TEXT.courseTile?.[offer?.slug] || ''}
          </Paragraph>
          <Headline level={4}>{trimText(removeParentheses(offer?.title || ''), 55)}</Headline>
        </div>
      </Link>
    </Style>
  );
};
